var map = {
	"./close-btn.webp": 1937,
	"./icon-caution.webp": 1938,
	"./icon-checked.webp": 1939,
	"./icon-contact-us.webp": 1940,
	"./icon-email.webp": 1941,
	"./icon-eye-close.webp": 1942,
	"./icon-eye-open.webp": 1943,
	"./icon-forget-phone.webp": 1944,
	"./icon-forget-whatsapp.webp": 1945,
	"./icon-google.webp": 1946,
	"./icon-login-email.webp": 1947,
	"./icon-password.webp": 1948,
	"./icon-robot-select.webp": 1949,
	"./icon-robot-unselect.webp": 1950,
	"./icon-telegram.webp": 1951,
	"./icon-user.webp": 1952,
	"./login-bg.webp": 1953,
	"./reglogin-bg-cn.webp": 1954,
	"./reglogin-bg-id.webp": 1955,
	"./reglogin-bg-ms.webp": 1956,
	"./reglogin-bg.webp": 1957,
	"./reglogin-m-bg-cn.webp": 1958,
	"./reglogin-m-bg-id.webp": 1959,
	"./reglogin-m-bg-ms.webp": 1960,
	"./reglogin-m-bg.webp": 1961
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 123;